import i18n from "@/i18n";

const STATE_ROWS_LIMIT = 10;

export default {
  props: {
    byState: {
      type: Boolean,
      default: false,
    },
    limitStates: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandedRows: {},
      allStatesRows: {},
      hoveredState: null,
    };
  },
  watch: {
    byState(enabled) {
      if (!enabled) {
        this.expandedRows = {};
        this.allStatesRows = {};
      }
    },
    limitStates() {
      this.allStatesRows = {};
    },
  },
  methods: {
    rowKey(item) {
      return item.rowKey || item.name;
    },
    isDifferenceRow(item) {
      return item.name === i18n.t("resources.ab_tests.difference");
    },
    isExpanded(item) {
      return Boolean(this.expandedRows[this.rowKey(item)]);
    },
    toggleRow(item) {
      if (!this.byState) {
        return;
      }

      const key = this.rowKey(item);

      this.$set(this.expandedRows, key, !this.isExpanded(item));
      this.$delete(this.allStatesRows, key);
    },
    showsAllStates(item) {
      return !this.limitStates || Boolean(this.allStatesRows[this.rowKey(item)]);
    },
    expandedStates(item) {
      if (!this.byState || !this.isExpanded(item)) {
        return [];
      }

      return this.showsAllStates(item) ? item.states : item.states.slice(0, STATE_ROWS_LIMIT);
    },
    exceedsStatesLimit(item) {
      return this.limitStates && this.isExpanded(item) && item.states.length > STATE_ROWS_LIMIT;
    },
    toggleAllStates(item) {
      const key = this.rowKey(item);

      this.$set(this.allStatesRows, key, !this.allStatesRows[key]);
    },
    showNoStateData(item) {
      return this.byState && this.isExpanded(item) && item.states.length === 0;
    },
  },
};
